import { Box, Typography } from '@mui/material';

const SectionTitle = ({
  icon: Icon,
  label,
}: {
  icon: React.ElementType;
  label: string;
}) => (
  <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={40}
      height={40}
      borderRadius={2}
      sx={{
        background: (theme) =>
          `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      }}
    >
      <Icon sx={{ color: 'white', fontSize: 22 }} />
    </Box>
    <Typography
      color="primary.main"
      variant="h5"
      fontWeight={700}
      sx={{
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: -4,
          width: '40%',
          height: 3,
          borderRadius: 99,
          bgcolor: 'secondary.main',
        },
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default SectionTitle;
